import {Injectable} from '@angular/core';
import {apiUrlMap} from '@ox/config';
import {VinPhoneVerifyResponse} from '@ox/typings';
import {AutoDestroy, BaseHttpService} from '@ox/utils';
import {map, of, Subject, takeUntil} from 'rxjs';


@Injectable()
export class LoginRegisterDataService {
    @AutoDestroy private destroy$: Subject<void> = new Subject<void>();

    constructor(private http: BaseHttpService) {}

    public matchLookup(type: string, attempt: string, token: string) {
        // TODO: Remove mock response and uncomment API call when API is ready
        const mockResponse = {
            vinValid: false,
            phoneValid: false,
            make: 'Chevrolet',
            model: 'Blazer',
            year: '2025'
        } as VinPhoneVerifyResponse;
        return of(mockResponse);
        //return this.http.get(apiUrlMap.onboard.lookup(type, attempt, token)).pipe(
        //     takeUntil(this.destroy$),
        //     map((response) => response.data)
        // );
    }
    
}